import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../../../modules/shared/services/catalog.service";
import { CclNavbarFooterService, CclMessageService } from "certain-common-library";
import { FlashMessagesService } from "angular2-flash-messages";

import { cloneDeep } from "lodash";
import { Subscription } from "rxjs";


@Component({
    selector: "rules-validation",
    templateUrl: "./rules-validations.view.html",
    providers: []
})
export class RulesValidationView implements OnInit, AfterViewInit, OnDestroy{
    sessionConfigObj: any = {};
    sessionConfig: any = {};
    subscription: Subscription;

    constructor(
        public sharedService: SharedService,
        private _flashMessagesService: FlashMessagesService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private catalogService: CatalogService
        ) {
            this.subscription = this.messageService.getMessage().subscribe(message => this.saveConfig(message));
        }

    ngOnInit() {
        this.loadConfigObj();
    }

    loadConfigObj(): void {
        this.sessionConfigObj = this.sharedService.configs[this.sharedService.configTypes.SESSION['general']];

        if (this.sessionConfigObj == null || this.sessionConfigObj.id == null) {
            this.sessionConfig = cloneDeep(this.sharedService.sessionLayoutConfig.general);
            this.sessionConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.SESSION['general']
            };
        } else {
            this.sessionConfig = JSON.parse(this.sessionConfigObj.config);
        }

        if(!('instanceCheckValidation' in this.sessionConfig.catalogConfig)) {
            this.sessionConfig.catalogConfig['instanceCheckValidation'] = false;
        }

        if(!('inventoryLock' in this.sessionConfig.catalogConfig)) {
            this.sessionConfig.catalogConfig['inventoryLock'] = false;
        }
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            this.navbarFooterService.navbar.rightNavbarItems[0].label = "";
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-rules-config";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-rules-config";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    toggleValidationButton(e): void {
        this.sessionConfig.catalogConfig['instanceCheckValidation'] = !this.sessionConfig.catalogConfig['instanceCheckValidation'];
    }

    toggleInventoryButton(e): void {
        this.sessionConfig.catalogConfig['inventoryLock'] = !this.sessionConfig.catalogConfig['inventoryLock'];
    }

    saveConfig(message): void {
        if (message.text == "save-rules-config" || message.text == "save-next-rules-config") {
            this.sessionConfigObj.config = JSON.stringify(this.sessionConfig);
            console.log('this.sessionConfig',this.sessionConfig);
            this.catalogService.saveSetupConfig(this.sessionConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.createCss(this.catalogService);
                this.sharedService.originalData = cloneDeep(this.sessionConfig);
                this.sharedService.changedData = this.sessionConfig;

                this.sessionConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                if(this.sharedService.setup.setupConfigs && this.sharedService.setup.setupConfigs.length>0) {
                    let index = this.sharedService.setup.setupConfigs.findIndex(elem => elem.id === this.sessionConfigObj.id);
                    this.sharedService.setup.setupConfigs[index] = this.sessionConfigObj;
                }
                this.sharedService.configs[this.sharedService.configTypes.SESSION['general']] = this.sessionConfigObj;
                this._flashMessagesService.show(
                    "Rules & Validations saved successfully.",
                    {
                        cssClass: "alert-success"
                    }
                );
                this.messageService.sendMessage("update-setting");
                if (message.text == "save-next-rules-config") {
                    this.messageService.sendMessage("attendee-preview");
                }
            });
        }
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }
}
